import { AdminLayout } from '@/components/layouts'
import { CategoryForm } from './CategoryForm'

interface Community {
  id: number
  name: string
}

interface ParentCategory {
  id: number
  name: string
  community_id: number
}

interface NewProps {
  communities: Community[]
  parent_categories: ParentCategory[]
  max_position: number
}

export default function New({ communities, parent_categories, max_position }: NewProps) {
  return (
    <AdminLayout
      title="Nouvelle catégorie"
      breadcrumbs={[
        { label: 'Catégories', href: '/admin/categories' },
        { label: 'Nouvelle catégorie' }
      ]}
    >
      <div className="max-w-2xl">
        <CategoryForm
          communities={communities}
          parentCategories={parent_categories}
          maxPosition={max_position}
          onSubmit="/admin/categories"
        />
      </div>
    </AdminLayout>
  )
}
